import { Input, Modal } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { TaskLink } from '../../types/TaskLink';
import { BaseButton } from '../UI/BaseButton';

interface TaskLinkModalProps {
  taskLink?: TaskLink;
  open: boolean;
  onAdd: (url: string, name: string) => void;
  onEdit: (taskLinkId: number, url: string, name: string) => void;
  onCancel: () => void;
  confirmLoading: boolean;
}

export const TaskLinkModal = (props: TaskLinkModalProps) => {
  const { open, onCancel, onAdd, onEdit, confirmLoading, taskLink } = props;
  const inputRef = useRef<any>(null);

  const [url, setUrl] = useState(taskLink?.link || '');
  const [name, setName] = useState(taskLink?.name || '');

  useEffect(() => {
    setUrl(taskLink?.link || '');
    setName(taskLink?.name || '');
  }, [taskLink]);

  useEffect(() => {
    if (open && inputRef.current) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    } else if (!open) {
      setUrl('');
      setName('');
    }
  }, [open]);

  return (
    <Modal
      title={
        <div className="justify-start text-brand-grey-dark text-base font-semibold mx-4 mt-3">
          {taskLink ? 'Edit a Link' : 'Add a Link'}
        </div>
      }
      open={open}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      centered
      width={640}
      footer={
        <div className="flex items-center justify-between gap-2 mt-6">
          <BaseButton type="secondary" size="medium" onClick={onCancel}>
            Cancel
          </BaseButton>
          <BaseButton
            type="primary"
            size="medium"
            disabled={!url}
            onClick={() => {
              if (taskLink) {
                onEdit(taskLink.id, url, name);
              } else {
                onAdd(url, name);
              }
            }}
          >
            {taskLink ? 'Save Changes' : 'Add Link'}
          </BaseButton>
        </div>
      }
    >
      <div className="flex flex-col gap-4 mx-4 mb-10 mt-6">
        <div className="flex flex-col gap-1">
          <div className="flex justify-start items-center gap-1 text-brand-grey-dark text-xs font-semibold">
            Displayed Text
            <div className="text-neutral-800 font-medium">(optional)</div>
          </div>
          <Input
            id="linkName"
            placeholder="Enter link name"
            autoComplete="off"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="flex flex-col gap-1">
          <div className="min-w-80 justify-start text-color-brand-colors-grey-dark text-xs font-semibold">URL</div>
          <Input
            id="taskLink"
            placeholder="Enter task URL"
            required
            autoComplete="off"
            value={url}
            ref={inputRef}
            onChange={(e) => setUrl(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
};
